<style src="../css/head.css">
</style>

<template>
  <div>
    <Head-section></Head-section>
    <br>
    <div class="container" style="text-align: center;">
   
   <br><br><p><h1>{{$t("message.Download_title")}}</h1></p>
   <br><br><br><br>
     <a href="http://cn.service.bluedio.com/sound7_1.zip" target="_blank"><img center src="../assets/download.png" width="240" height="240" alt="Bluedio" /></a>
    <br><br><br>
    <dt>{{$t("message.Download_desc")}}</dt>
    <dt><h3>http://cn.service.bluedio.com/sound7_1.zip</h3></dt>      
   <br>
  </div>
  <br><br><br><br><br>
  
    <Foot-section></Foot-section>
  </div>
</template>

<script>
  import HeadSection from "./HeadSection.vue";
  import FootSection from "./FootSection.vue";
  import {
    mapActions,
    mapGetters
  } from "vuex";
  // import * as api from "../api";

  // import axios from "axios";
  export default {
    name: "Download",
    components: {
      HeadSection,
      FootSection
    },
    metaInfo() {
    return {
      meta: [
        {
          name: "Content-Security-Policy",
          content: "upgrade-insecure-requests",
        },
      ],
    };
  },
    data() {
     return {
        mainProps: { blank: true, width: 240, height: 240, class: 'm1' }
      }
    },
    mounted() {
     
    },
    computed: {
      ...mapGetters(["lan"])
    },
    watch: {
      
    },
    methods: {
    }
  };
</script>